<template>
  <div>
    <Alert></Alert>
    <loading :active.sync="isLoading" background-color="#D0D0D0	">
      <div class="loadingio-spinner-eclipse-y24d302hfm">
        <div class="ldio-f9ujl5oazv5">
          <div></div>
        </div>
      </div>
    </loading>
    <div id="SliderTop">
      <i class="fas fa-2x fa-chevron-up toTop-arrow"></i>
    </div>

    <div class="data-box " v-if="ListStatus">
      <Userlist></Userlist>
    </div>
    <div v-if="show">
      <router-view> </router-view>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import { mapGetters } from 'vuex'
  import Userlist from '@/components/Userlist.vue'
  import Alert from '@/components/Alert.vue'

  import isMobile from 'ismobilejs'
  import ConversationClient from 'conversation-client'

  export default {
    name: 'Home',

    components: {
      Userlist,
      ConversationClient,
      Alert,
    },

    data() {
      return {
        show: true,
        proInterestList: [],
        optionInterPro: [], //給選擇興趣的產品欄位用
        s_optionInterPro: '',
        categoryAll: [],
        s_categoryAll: '',

        OnlineExpoStatus: '', //判斷狀態
        mobile: isMobile(window.navigator).any,
        Nowdate: '',
        ExpoBegin: '',
        ExpoEnd: '',
        ExpoPreOpen: '',
        access_token: '',
      }
    },

    computed: {
      ...mapGetters(['isLoading', 'ListStatus', 'Roomvisible', 'UnreadNum', 'exhcode']),
    },

    watch: {
      optionInterPro: function(newValue) {
        this.s_optionInterPro = newValue.toString()
      },
      categoryAll: function(newValue) {
        this.s_categoryAll = newValue.toString()
      },

      Roomvisible(v) {
        if (v && this.mobile) {
          document.getElementById('myDIV').classList.add('disable-pull')
        } else {
          document.getElementById('myDIV').classList.remove('disable-pull')
        }
      },

      UnreadNum(newValue) {
        if (this.UnreadNum !== newValue) {
          this.$store.dispatch('getUnread', newValue)
        }
      },
    },

    methods: {
      alertSuccess(Status) {
        const vm = this

        vm.$swal({
          title: vm.alertTitle,
          text: vm.alertText,
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
          allowEnterKey: true,
        }).then(function() {
          if (Status == 'Out') {
            vm.show = true
          } else if (Status == 'In') {
            window.location.replace(`https://www.chanchao.com.tw/bioasiataiwan/onlineexpo/Exhibitors/Page=1`)
          }
        })
      },

      alertError() {
        const vm = this
        vm.$swal({
          text: vm.alertText,
          icon: 'info',
          confirmButtonText: 'OK',

          allowOutsideClick: true,
          allowEnterKey: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        })
      },
    },

    created() {
      //判斷開啟頁面有無使用觸碰功能以評估桌機行動裝置
      function isMobile() {
        try {
          document.createEvent('TouchEvent')
          return true
        } catch (e) {
          return false
        }
      }

      if (!isMobile()) {
        //桌機就啟動tooltip提示功能
        $('body').tooltip({ selector: '[data-toggle=tooltip]' })
      }

      const vm = this

      vm.$store.dispatch('updateLoading', true)
      vm.show = false

      //置頂
      $(() => {
        $('#SliderTop').click(() => {
          $('html,body').animate({ scrollTop: 0 }, 'slow')
          return false
        })

        $(window)
          .scroll(function() {
            if ($(this).scrollTop() > 300) {
              $('#SliderTop').fadeIn(222)
            } else {
              $('#SliderTop')
                .stop()
                .fadeOut(222)
            }
          })
          .scroll()
      })

      let NowPageUrl = location.href
      let Urlname = NowPageUrl.split('/')[5]

      if (Urlname == 'ExhibitorDetail') {
        sessionStorage.setItem('Exhurl', NowPageUrl)
      }

      //取得當前時間

      vm.$http
        .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/Exhibitions/4BCC3A06EB93B769FC2E7D0B51BF2383?lang=en`)
        .then((response) => {
          //先取得時間段API

          vm.Nowdate = Date.parse(new Date()).valueOf()
          vm.ExpoBegin = response.data.OnlineExpoBegin
          vm.ExpoEnd = response.data.OnlineExpoEnd
          vm.ExpoPreOpen = response.data.OnlineExpoMovein

          if (Urlname !== 'Login' && Urlname !== 'Registration' && Urlname !== 'Signup' && Urlname !== 'Landing') {
            const api = `https://www.chanchao.com.tw/apiLogin/v1/isAuthenticated`
            const info = null

            vm.$http.post(api, info).then((response) => {
              if (response.data == 200) {
                sessionStorage.setItem('access', '200')

                const registerApi = `https://www.chanchao.com.tw/apiOnlineExpo/v1/CheckRegister/${vm.exhcode}`
                vm.$http.post(registerApi).then((response) => {
                  if (response.data == 200) {
                    // 判斷非參展商的時間段

                    if (vm.Nowdate < vm.ExpoBegin) {
                      vm.OnlineExpoStatus = 1
                    } else if (vm.Nowdate >= vm.ExpoBegin && vm.Nowdate <= vm.ExpoEnd) {
                      vm.OnlineExpoStatus = 2
                    } else if (vm.Nowdate > vm.ExpoEnd) {
                      vm.OnlineExpoStatus = 3
                    }

                    if (vm.OnlineExpoStatus == 2) {
                      vm.show = true
                      vm.$store.dispatch('updateLoading', false)
                    } else {
                      window.location.replace(`https://www.chanchao.com.tw/bioasiataiwan/onlineexpo/Landing`)
                    }
                  } else if (response.data == 252) {
                    alert('Please complete the questionnaire to finish the visit registration')

                    window.location.replace(`https://www.chanchao.com.tw/bioasiataiwan/onlineexpo/Registration`)
                  } else if (response.data == 251) {
                    window.location.replace(`https://www.chanchao.com.tw/en/`)
                  } else if (response.data == 253) {
                    vm.show = true
                    vm.$store.dispatch('updateLoading', false)
                  } else if (response.data == 254) {
                    // 判斷參展商用戶時間段

                    if (vm.Nowdate < vm.ExpoPreOpen) {
                      vm.OnlineExpoStatus = 1
                    } else if (vm.Nowdate >= vm.ExpoPreOpen && vm.Nowdate <= vm.ExpoEnd) {
                      vm.OnlineExpoStatus = 2
                    } else if (vm.Nowdate > vm.ExpoEnd) {
                      vm.OnlineExpoStatus = 3
                    }

                    if (vm.OnlineExpoStatus == 2) {
                      vm.show = true
                      vm.$store.dispatch('updateLoading', false)
                    } else {
                      window.location.replace(`https://www.chanchao.com.tw/bioasiataiwan/onlineexpo/Landing`)
                    }
                  }
                })
              } else {
                //251 的狀態
                sessionStorage.setItem('access', '')
                sessionStorage.removeItem('access')
                alert('You are not logged in.')

                window.location.replace(`https://www.chanchao.com.tw/bioasiataiwan/onlineexpo/Landing`)
              }
            })
          } else if (Urlname == 'Login') {
            //時間段判斷(只需取出畢展日期即可，當到期時就導到landing頁)
            //下方就不用時間段判斷來判定，直接比較日期

            if (vm.Nowdate < vm.ExpoEnd) {
              const api = `https://www.chanchao.com.tw/apiLogin/v1/isAuthenticated`
              const info = null

              vm.$http.post(api, info).then((response) => {
                if (response.data == 200) {
                  alert('You are already logged in.')
                  window.location.replace(`https://www.chanchao.com.tw/bioasiataiwan/onlineexpo/Home`)
                } else {
                  vm.show = true
                  vm.$store.dispatch('updateLoading', false)
                }
              })
            } else {
              window.location.replace(`https://www.chanchao.com.tw/bioasiataiwan/onlineexpo/Landing`)
            }
          } else if (Urlname == 'Registration') {
            //登錄功能外層設定是確定未畢展的情況下，都要能進去
            if (vm.Nowdate < vm.ExpoEnd) {
              const api = `https://www.chanchao.com.tw/apiLogin/v1/isAuthenticated`
              const info = null

              vm.$http.post(api, info).then((response) => {
                if (response.data == 200) {
                  const registerApi = `https://www.chanchao.com.tw/apiOnlineExpo/v1/CheckRegister/${vm.exhcode}`
                  vm.$http.post(registerApi).then((response) => {
                    if (response.data == 200) {
                      alert('You are already registered .')
                      window.location.replace(`https://www.chanchao.com.tw/bioasiataiwan/onlineexpo/Home`)
                    } else if (response.data == 252) {
                      vm.show = true
                      vm.$store.dispatch('updateLoading', false)
                    } else if (response.data == 251) {
                      window.location.replace(`https://www.chanchao.com.tw/en/`)
                    } else if (response.data == 253) {
                      alert('You are already registered .')
                      window.location.replace(`https://www.chanchao.com.tw/bioasiataiwan/onlineexpo/Home`)
                    } else if (response.data == 254) {
                      alert('You are already registered .')
                      window.location.replace(`https://www.chanchao.com.tw/bioasiataiwan/onlineexpo/Home`)
                    }
                  })
                } else {
                  alert('You are not logged in. ')
                  window.location.replace(`https://www.chanchao.com.tw/bioasiataiwan/onlineexpo/Landing`)
                }
              })
            } else {
              window.location.replace(`https://www.chanchao.com.tw/bioasiataiwan/onlineexpo/Landing`)
            }
          } else if (Urlname == 'Signup') {
            if (vm.Nowdate < vm.ExpoEnd) {
              vm.show = false
              vm.$store.dispatch('updateLoading', true)

              const api = `https://www.chanchao.com.tw/apiLogin/v1/isAuthenticated`
              const info = null

              vm.$http.post(api, info).then((response) => {
                if (response.data == 200) {
                  alert('You are already logged in.')
                  window.location.replace(`https://www.chanchao.com.tw/bioasiataiwan/onlineexpo/Home`)
                } else {
                  vm.show = true
                  vm.$store.dispatch('updateLoading', false)
                }
              })
            } else {
              window.location.replace(`https://www.chanchao.com.tw/bioasiataiwan/onlineexpo/Landing`)
            }
          } else if (Urlname == 'Landing') {
            const api = `https://www.chanchao.com.tw/apiLogin/v1/isAuthenticated`
            const info = null

            vm.$http.post(api, info).then((response) => {
              if (response.data == 200) {
                const registerApi = `https://www.chanchao.com.tw/apiOnlineExpo/v1/CheckRegister/${vm.exhcode}`
                vm.$http.post(registerApi).then((response) => {
                  if (response.data == 200) {
                    // 判斷非參展商的時間段

                    if (vm.Nowdate < vm.ExpoBegin) {
                      vm.OnlineExpoStatus = 1
                    } else if (vm.Nowdate >= vm.ExpoBegin && vm.Nowdate <= vm.ExpoEnd) {
                      vm.OnlineExpoStatus = 2
                    } else if (vm.Nowdate > vm.ExpoEnd) {
                      vm.OnlineExpoStatus = 3
                    }

                    if (vm.OnlineExpoStatus == 2) {
                      window.location.replace(`https://www.chanchao.com.tw/bioasiataiwan/onlineexpo/Home`)
                    } else {
                      vm.show = true
                      vm.$store.dispatch('updateLoading', false)
                    }
                  } else if (response.data == 252) {
                    vm.show = true
                    vm.$store.dispatch('updateLoading', false)
                  } else if (response.data == 251) {
                    window.location.replace(`https://www.chanchao.com.tw/en/`)
                  } else if (response.data == 253) {
                    // console.log('Exhibition closed')
                    vm.show = true
                    vm.$store.dispatch('updateLoading', false)
                  } else if (response.data == 254) {
                    // 判斷參展商用戶時間段

                    if (vm.Nowdate < vm.ExpoPreOpen) {
                      vm.OnlineExpoStatus = 1
                    } else if (vm.Nowdate >= vm.ExpoPreOpen && vm.Nowdate <= vm.ExpoEnd) {
                      vm.OnlineExpoStatus = 2
                    } else if (vm.Nowdate > vm.ExpoEnd) {
                      vm.OnlineExpoStatus = 3
                    }

                    if (vm.OnlineExpoStatus == 2) {
                      window.location.replace(`https://www.chanchao.com.tw/bioasiataiwan/onlineexpo/Home`)
                    } else {
                      vm.show = true
                      vm.$store.dispatch('updateLoading', false)
                    }
                  }
                })
              } else {
                vm.show = true
                vm.$store.dispatch('updateLoading', false)
              }
            })
          }
        })
    },
  }
</script>

<style lang="scss">
  .data-box {
    position: fixed;
    top: 88px;
    right: 79px;
    width: 270px;
    height: 400px;
    z-index: 2900;
  }
  .title_fontStyle {
    color: #575757;
  }

  a:hover {
    color: #707272;
    text-decoration: none;
  }

  a {
    color: #2d2e2e;
  }

  .pointer {
    cursor: pointer;
  }

  p {
    margin-top: 0;
    margin-bottom: 0rem;
  }

  ul {
    list-style: none;
  }

  .pagination-sm .page-link {
    padding: 7px;
    font-size: 1rem;
  }

  .pagination-lg .page-link {
    padding: 6px;
    font-size: 0.9rem;
  }

  .page-link {
    color: #000000;
    &:hover {
      color: #666666;
    }
  }

  .page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: #2584bf;
    border-color: #c9c9c9;
  }

  .brightnessHover {
    &:hover {
      filter: brightness(1.2);
      cursor: pointer;
    }
  }

  .breadcrumb {
    background-color: #f8f8f8;
  }

  .ellipsis_breadcrumb {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    white-space: normal;
  }

  .MbDevice {
    display: none;
  }

  .PcDevice {
    display: block;
  }

  @media (max-width: 960px) {
    .MbDevice {
      display: block;
    }

    .PcDevice {
      display: none;
    }
  }

  //Logo長度設定
  .WidthLongLogo {
    display: block;
  }

  .WidthShortLogo {
    display: none;
  }

  @media (max-width: 1700px) {
    .WidthLongLogo {
      display: none;
    }

    .WidthShortLogo {
      display: block;
    }
  }

  .BannerHover {
    transition: all 0.3s;

    &:hover {
      box-shadow: 2px 2px 15px 8px rgba(255, 255, 255, 0.322);
      opacity: 0.9;
      cursor: pointer;
      filter: brightness(1.1);
    }
  }

  .BusCard_Hover {
    transition: all 0.3s;

    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }
  }

  //圖片卡片資訊

  .card-effect {
    border-radius: 0.25rem;
    &:hover {
      box-shadow: 1px 1px 8px 1px #d1cfcf;
      filter: brightness(1.1);
    }
  }

  @keyframes ldio-f9ujl5oazv5 {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .ldio-f9ujl5oazv5 div {
    position: absolute;
    animation: ldio-f9ujl5oazv5 1s linear infinite;
    width: 160px;
    height: 160px;
    top: 20px;
    left: 20px;
    border-radius: 50%;
    box-shadow: 0 4px 0 0 #777b7c;
    transform-origin: 80px 82px;
    z-index: 10002;
  }
  .loadingio-spinner-eclipse-y24d302hfm {
    width: 200px;
    height: 200px;
    display: inline-block;
    overflow: hidden;
    z-index: 10002;
  }
  .ldio-f9ujl5oazv5 {
    width: 100%;
    height: 100%;
    position: relative;
    transform: translateZ(0) scale(1);
    backface-visibility: hidden;
    transform-origin: 0 0; /* see note above */
    z-index: 10002;
  }
  .ldio-f9ujl5oazv5 div {
    box-sizing: content-box;
    z-index: 10002;
  }

  //scrollTop

  .toTop-arrow {
    position: fixed;
    bottom: 30px;
    right: 5px;
    width: 50px;
    height: 50px;
    // background: #dfd5dd;
    border-style: solid;
    border-color: #eeeeee;
    // padding: 5px;
    padding-left: 9px;
    padding-top: 5px;
    font-size: 31px;
    z-index: 3000;
    cursor: pointer;
    opacity: 0.7;
    border-radius: 30px;
    color: #2b2b2b;

    background-image: linear-gradient(270deg, #e8e0c4, #bebdba);

    &:hover {
      background: #d4d4d4;
      transform: scale(1.05);
    }
  }

  .floatChatIcon {
    position: fixed;
    bottom: 100px;
    right: 5px;
    width: 50px;
    height: 50px;
    background: #e03a3abc;
    border-radius: 30px;
    padding: 5px;
    z-index: 800;
    cursor: pointer;
    opacity: 0.7;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 3000;
  }

  .floatChatIcon:after {
    content: '';
    display: block;
    position: absolute;
    top: -6px;
    left: -6px;
    right: -6px;
    bottom: -6px;
    background-color: #8484840f;
    border-radius: 99em;
  }

  .unreadFrame {
    position: relative;
  }

  .mesbadge {
    position: absolute;
    top: 12px;
    right: 28px;
    font-size: 13px;
    background-color: #e0492e;
    color: #fff;
  }

  .modal-title-bg {
    background-color: #ecf0f8;
  }

  .modal-content {
    border: 0px;
  }

  #myDIV {
    z-index: 4002;
  }

  .Chatbox {
    position: fixed;
    bottom: 0px;
    right: 0px;
    width: 900px;
    height: 590px;
    z-index: 4000;
  }

  .disable-pull {
    position: fixed;
    top: 0px;
    bottom: 0px;
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: hidden;
  }

  .mobile {
    right: 0;
    width: 100%;
    height: 100%;
  }

  .minimal {
    width: 0;
    height: 0;
  }

  .iconOpenHover {
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
      transform: scale(1.2);
    }
  }

  .recommend-title {
    position: relative;
    text-align: center;
    padding: 2rem 0;
    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      border-top: 2px solid #2584bf;
      width: 100%;
      z-index: -1;
    }
    .recommend-content {
      z-index: 1;
      background-color: #ffffff;
      padding: 0 2rem;
      font-size: 1.5rem;
      margin-bottom: 0.5rem;
      font-weight: 500;
      line-height: 1.2;
    }
  }

  .swal2-container {
    z-index: 10001;
  }

  //淡出動畫效果
  @keyframes flicker {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.7;
    }
    100% {
      opacity: 1.2;
    }
  }
  .flicker {
    animation: flicker 1.5s linear;
    animation-iteration-count: 2;
  }

  @keyframes flicker_card {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 2;
    }
  }

  .flicker_card {
    animation: flicker_card 1s infinite;
  }

  .btn-primary {
    filter: drop-shadow(2px 2px 2px #bebebe87);
  }

  .dropdown-menu li:hover .sub-menu {
    visibility: visible;
  }
  .dropdown:hover .dropdown-menu {
    display: block;
  }

  .dropdown-menu {
    background-color: #151515c7;
    margin: 0px;
    padding: 0.7rem 0;
  }

  .dropdown-item {
    display: block;
    width: 100%;
    padding: 1.5rem 2rem;
    clear: both;
    color: #ffffff;
    text-align: inherit;
    white-space: nowrap;
    background-color: transparent;
    border: 0px;
    transition: all 0.3s ease;
    font-size: 17px;

    &:hover {
      background-color: #2584bf;
      color: #ffffff;
    }
  }

  @media (max-width: 991px) {
    .dropdown-menu {
      background-color: #ffffff;
    }
    .dropdown-item {
      color: #070707;
      font-size: 17px;
    }
  }

  .info_size {
    font-size: 18px;
  }

  .badge {
    border-radius: 50px;
  }

  .close {
    font-size: 2.5rem;
  }

  .navbar_border {
    border-bottom: #006dccd9 2px solid;
  }

  .title_style {
    border-left: 3px solid #2584bf;
    padding: 0 20px;
  }
</style>
